window.addEventListener('DOMContentLoaded', function () {
  const quizEls = document.querySelectorAll('[data-quiz]');
  if (quizEls.length === 0) {
    return;
  }
  quizEls.forEach(el => {
    const welcomeEl = el.querySelector('.quiz-welcome');
    const sectionEls = el.querySelectorAll('.quiz-section');
    const resultsEls = el.querySelectorAll('.quiz__results');
    const startEl = el.querySelector('.quiz-start-button');
    const nameEl = el.querySelector('.quiz-name');
    const progressEls = el.querySelectorAll('.quiz-progress__segment');

    // Click start button and check if there is a valid email
    startEl.addEventListener('click', e => {
      if (nameEl.value !== '') {
        const email = nameEl.value;
        startQuiz(email);
      } else {
        nameEl.focus();
      }
    });

    // Start quiz
    function startQuiz(email) {

      // Hide the email section and begin the quiz
      sectionEls.forEach((el) => {
        el.classList.remove('active');
        if (el.getAttribute('data-section') === '2') {
          el.classList.add('active');
          progressEls.forEach((el, index) => {
            if (index === 0) {
              el.classList.add('complete');
            }
          });
        }

        // Get next/previous buttons
        const prevEl = el.querySelector('.quiz-prev');
        const nextEl = el.querySelector('.quiz-next');

        // Get inputs (checkboxes or radio buttons)
        const inputEls = el.querySelectorAll('input');

        if (prevEl !== null) {
          prevEl.addEventListener('click', e => {

            // Back to stage 2
            if (el.getAttribute('data-section') === '2') {
              el.classList.remove('active');
              sectionEls.forEach((el) => {
                if (el.getAttribute('data-section') === '1') {
                  el.classList.add('active');
                }
              });
              // Move progress indicator
              progressEls.forEach((el, index) => {
                el.classList.remove('complete');
              });
            } else {
              // Hide current section
              el.classList.remove('active');
              // Go to previous section
              const prevSection = prevEl.getAttribute('data-prev');
              sectionEls.forEach((el) => {
                el.classList.remove('active');
                if (el.getAttribute('data-section') === prevSection) {
                  el.classList.add('active');
                }
                inputEls.forEach(el => {
                  if (el.checked) {
                    nextEl.removeAttribute('disabled');
                  }
                });
              });
              // Move progress indicator
              progressEls.forEach((el, index) => {
                el.classList.remove('complete');
                if (index <= prevSection - 2) {
                  el.classList.add('complete');
                }
              });
            }

          });
        }

        if (nextEl !== null) {

          inputEls.forEach((el) => {

            // Enable the next button if there is a valid input
            if (el.checked) {
              nextEl.removeAttribute('disabled');
            }
            el.addEventListener('change', e => {
              if (isValid(inputEls)) {
                nextEl.removeAttribute('disabled');
              } else {
                nextEl.setAttribute('disabled', 'disabled');
              }
            });
          });

          // Onwards to stage 3
          nextEl.addEventListener('click', e => {
            if (el.getAttribute('data-section') === '2') {
              el.classList.remove('active');
              sectionEls.forEach((el) => {
                if (el.getAttribute('data-section') === '3') {
                  el.classList.add('active');
                }
              });
              // Move progress indicator
              progressEls.forEach((el, index) => {
                el.classList.remove('complete');
                if (index === 0 || index === 1) {
                  el.classList.add('complete');
                }
              });
            } else {
              // If a Yes/No question (stage 3 and beyond) go to the next question or a results screen
              const answerEl = el.querySelector('input:checked');
              if (answerEl.hasAttribute('data-result')) {
                // Go to a results screen
                sectionEls.forEach((el) => {
                  el.classList.remove('active');
                });
                welcomeEl.classList.remove('active');
                resultsEls.forEach(resultsEl => {
                  resultsEl.classList.remove('active');
                  if (resultsEl.getAttribute('data-results') == answerEl.getAttribute('data-result')) {
                    resultsEl.classList.add('active');
                    // Subscribe to relevant Klaviyo form
                    const formEl = resultsEl.querySelector('form.needsclick');
                    if (formEl !== null) {
                      const nameInputEl = formEl.querySelector('input[type="text"]');
                      //nameInputEl.value = nameEl.value;
                    }
                    const skipEl = resultsEl.querySelector('.quiz__results-anyway');
                    if (skipEl !== null) {
                      skipEl.addEventListener('click', e => {
                        resultsEl.classList.add('quiz__results--gate-active');
                      });
                    }
                  }
                });
                // Move progress indicator to the end
                progressEls.forEach((el, index) => {
                  el.classList.add('complete');
                });
              } else {
                // Go to the next step
                const nextSection = nextEl.getAttribute('data-next');
                sectionEls.forEach((el) => {
                  el.classList.remove('active');
                  if (el.getAttribute('data-section') === nextSection) {
                    el.classList.add('active');
                  }
                });
                // Move progress indicator
                progressEls.forEach((el, index) => {
                  el.classList.remove('complete');
                  if (index < nextSection - 1) {
                    el.classList.add('complete');
                  }
                });
              }
            }
          });
        }
      });
    }

    // Check if there is a valid answer (at least one checked input)
    function isValid(els) {
      let result = false;
      els.forEach(el => {
        if (el.checked) {
          result = true;
        }
      });
      return result;
    }
  });
});
